import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $menuState, getMenuItemsByPageIdFx } from '@nx-frontend/shared/store/feature-menu-tree';
import { $page } from '@nx-frontend/shared/store/portal-page';
import { MenuItem, MenuType, PortalMenuTypes } from '@nx-frontend/shared/types/menu';

interface GetCurrentMenuItemProps {
  menuTypes?: MenuType[];
}

interface MenuItemResult {
  item: MenuItem;
  menuType: MenuType;
}

export const useGetCurrentMenuItem = ({ menuTypes = PortalMenuTypes }: GetCurrentMenuItemProps = {}):
  | MenuItemResult
  | undefined => {
  const [menuItem, setMenuItem] = useState<MenuItemResult | undefined>(undefined);
  const [page, menuState, getMenuItemsByPageId] = useUnit([$page, $menuState, getMenuItemsByPageIdFx]);

  useEffect(() => {
    getMenuItemsByPageId({
      menuTypes,
      pageId: page.id,
    }).then((result) => result?.item && setMenuItem({ item: result.item, menuType: result.menuType }));
  }, [page.id, menuState, getMenuItemsByPageId, menuTypes]);

  return menuItem;
};
